<template>
  <c-footer :fixed="false">
    <c-row style="width: 100%">
      <c-col sm="12" md="11">
        <a href="https://koalaboss.com" target="_blank">
          <template v-if="$store.state.app.authenticatedUser.organisation.name.indexOf('Aspen') !== -1">
            KoalaBoss Enterprise Edition for {{ $store.state.app.authenticatedUser.organisation.name }}
<!--            KoalaBoss Enterprise Edition (v{{ $store.state.app.version }}) for {{ $store.state.app.authenticatedUser.organisation.name }}-->
          </template>
          <template v-else>
            KoalaBoss
          </template>
          </a>
        <span class="ml-1">&copy; {{ new Date().getFullYear() }}</span>
      </c-col>
      <c-col sm="12" md="1">
        <span class="text-muted float-md-right">v{{ $store.state.app.version }}</span>
      </c-col>
    </c-row>
  </c-footer>
</template>

<script>
export default {
  name: 'TheFooter',
};
</script>
